import ChoiceDefinition from './choice-definition';
import ChoiceDefinitionOption from './choice-definition-option';

type ChoiceDefinitionOptionMetaData = Pick<ChoiceDefinitionOption, 'id' | 'label' | 'value' | 'modifiedDate'>;

type ChoiceDefinitionMetadataType = Pick<ChoiceDefinition, 'RecordId' | 'id' | 'name'> & {
  choices: ChoiceDefinitionOptionMetaData[];
};

export class ChoiceDefinitionMetadata implements ChoiceDefinitionMetadataType {
  RecordId: number;
  id: number;
  name: string;
  choices: ChoiceDefinitionOptionMetaData[];

  constructor(record: ChoiceDefinition) {
    this.RecordId = record.RecordId;
    this.id = record.id;
    this.name = record.name;
    this.choices = record.choices.map(choice => {
      return {
        id: choice.id,
        label: choice.label,
        value: choice.value,
        modifiedDate: choice.modifiedDate,
      };
    });
  }
}
